import { alpha, ListItemText, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';

export const HeaderStyled = styled('header')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  minHeight: 48,
  height: 50,
  width: '100vw',
  padding: '0 2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxShadow: '1px 2px 2px #c1c1c1cc',
  '& .logo': {
    maxHeight: 50,
    height: 30,
    objectFit: 'contain',
    '@media (max-width: 700px)': {
      height: 35,
    },
  },
  '& .logoSIOON': {
    height: 20,
    objectFit: 'contain',
    '@media(max-width: 700px)': {
      height: 16,
    },
  },
}));

export const TitleStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.gray,
  position: 'absolute',
  left: 100,
  fontSize: '20px',
}));

export const LogoutButtonStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  '& svg': {
    fontSize: 20,
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.3),
    borderRadius: 4,
    cursor: 'pointer',
  },
  '@media (max-width: 700px)': {
    '& h3': {
      display: 'none',
    },
    '& svg': {
      fontSize: 18,
    },
  },
}));

export const ActiveNavLinkStyled = styled(NavLink)(({ theme }) => ({
  '& svg, p': {
    color: `${theme.palette.global.lightgray}CC !important`,
  },
}));

export const ExitAdminStyled = styled('div')(({ theme }) => ({
  width: '100%',
  marginBottom: '25%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 4,
  padding: 8,
  '& svg': {
    fontSize: 20,
    color: theme.palette.global.lightgray,
  },
  '& h3': {
    color: theme.palette.global.lightgray,
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.lightgray, 0.1),
    cursor: 'pointer',
  },
}));

export const ListItemTextStyled = styled(ListItemText)(({ theme }) => ({
  color: theme.palette.global.gray,
}));
